export const uploadFile = async (file: File, token: string) => {
  try {
    // Validate file
    if (!file) {
      throw new Error('No file provided');
    }

    // Create FormData
    const formData = new FormData();
    formData.append('file', file);
    formData.append('name', file.name);

    // Prepare headers
    const headers: any = {};
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    // Make the upload request
    const response = await fetch(
      // 'https://hrx-api.retail-x.org/api/v1/attendance/upload-photo',
      'https://hrx-api.retail-x.org/api/v1/data-dump/upload-File',
      {
        method: 'POST',
        headers: headers,
        body: formData,
      },
    );

    // Parse response
    const data = await response.json();

    // Check if request was successful
    if ((data.status as string) !== 'success') {
      throw new Error(
        data.message || `Upload failed with status ${response.status}`,
      );
    }

    // Return success with file URL
    return {
      success: true,
      fileUrl: data?.file?.url,
      data: data?.data,
    };
  } catch (error: any) {
    console.error('File upload error:', error);
    return {
      success: false,
      error: error.message || 'Upload failed',
    };
  }
};

export const getFileNameFromUrl = (url: string): string => {
  if (!url) return '';
  try {
    const pathname = new URL(url).pathname;
    return pathname.split('/').pop() || '';
  } catch {
    return url.split('/').pop() || '';
  }
};
